import apiService from './apiService';

const productService = {
  list: ({ includeInactive = false } = {}) =>
    apiService.get('/products', { params: includeInactive ? { includeInactive: 'true' } : {} }),
  create: (payload) => apiService.post('/products', payload),
  update: (id, payload) => apiService.put(`/products/${id}`, payload),
  remove: (id) => apiService.delete(`/products/${id}`),
};

export default productService;
